<template>
    <OvbApp :app="app"></OvbApp>
</template>

<script>
import OvbApp from './basecomponents/OvbApp.vue';

export default {
    name: 'App',
    components: {
        OvbApp,
    },
    props: {
        app: {
            required: true,
            type: Object,
        },
    },
};
</script>

<style scoped>

</style>
